/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UpsertSettingsRequestBody = {
  /**
   * Whether skill efficacy scoring is enabled.
   */
  enabled: boolean;
  /**
   * Lifetime evaluations a new skill version may reserve before the per-skill daily cap applies.
   */
  newVersionBurst: number;
  /**
   * Maximum evaluations reserved across the organization each UTC day.
   */
  orgDailyCap: number;
  /**
   * Maximum evaluations reserved per skill each UTC day.
   */
  perSkillDailyCap: number;
};

/** @internal */
export type UpsertSettingsRequestBody$Outbound = {
  enabled: boolean;
  new_version_burst: number;
  org_daily_cap: number;
  per_skill_daily_cap: number;
};

/** @internal */
export const UpsertSettingsRequestBody$outboundSchema: z.ZodMiniType<
  UpsertSettingsRequestBody$Outbound,
  UpsertSettingsRequestBody
> = z.pipe(
  z.object({
    enabled: z.boolean(),
    newVersionBurst: z.int(),
    orgDailyCap: z.int(),
    perSkillDailyCap: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      newVersionBurst: "new_version_burst",
      orgDailyCap: "org_daily_cap",
      perSkillDailyCap: "per_skill_daily_cap",
    });
  }),
);

export function upsertSettingsRequestBodyToJSON(
  upsertSettingsRequestBody: UpsertSettingsRequestBody,
): string {
  return JSON.stringify(
    UpsertSettingsRequestBody$outboundSchema.parse(upsertSettingsRequestBody),
  );
}
